import { EnvelopeIcon, EnvelopeSimpleIcon, UserIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopText } from '../../../../ui'
import Scoop from '../../../../../assets/common/NewLogo.svg'
import Gmail from '../../../../../assets/appconnect/Gmail.svg'
import Outlook from '../../../../../assets/appconnect/Outlook.svg'
import styles from './ConnectSource.module.scss'

export const ConnectSource = ({ source, goBack, goForward }) => {
    return (
        <div className={styles.container}>
            <ScoopText className={styles.introText}>
                Great, your data is now ready to Scoop! It's now time to auto-forward your{' '}
                {source.name} report emails to Scoop
            </ScoopText>
            <div className={styles.content}>
                <div className={styles.flowContainer}>
                    <div className={styles.iconBox}>
                        <img src={source.icon} alt={source.name} />
                    </div>
                    <div className={styles.dashedLine} />
                    <EnvelopeIcon size={24} />
                    <div className={styles.dashedLine} />
                    <div className={styles.iconBox}>
                        <UserIcon size={24} />
                    </div>
                    <div className={styles.dashedLine} />
                    <EnvelopeIcon size={24} />
                    <div className={styles.dashedLine} />
                    <div className={styles.logoBox}>
                        <img src={Scoop} alt="Scoop" />
                    </div>
                </div>
                <ScoopText className={styles.emailProviderText}>
                    Where do you receive your {source.name} report emails?
                </ScoopText>
                <div className={styles.buttonContainer}>
                    <ScoopButton
                        className={styles.emailButton}
                        variant="secondary"
                        onClick={() => {}}
                        leftSection={<img src={Gmail} alt="Gmail" className={styles.buttonIcon} />}
                    >
                        Gmail
                    </ScoopButton>
                    <ScoopButton
                        className={styles.emailButton}
                        variant="secondary"
                        onClick={() => {}}
                        leftSection={
                            <img src={Outlook} alt="Outlook" className={styles.buttonIcon} />
                        }
                    >
                        Outlook
                    </ScoopButton>
                    <ScoopButton
                        className={styles.emailButton}
                        variant="secondary"
                        onClick={goForward}
                        leftSection={<EnvelopeSimpleIcon size={20} />}
                    >
                        Other
                    </ScoopButton>
                </div>
            </div>
        </div>
    )
}
